import { formatTimeAsHHMM } from "screens/modals/EditCompanyWorkingHoursModal";
import { TimeRangeValidationError } from "./WeekDayTableRow";

// We display time/duration as pixels on a scale of 10 over 236px (=24 hours)
// there is still a small gap for the minutes, as we're not adding pixels for the minutes above XX:60
// we could make a mapping from 60 minutes to 100 pixels to be exact
// 00:00 = 0px
// 23:59 = 235px


export const TimeVisualiser = ({ startTime, endTime, timeRangeValidationError }: {
    startTime: string | undefined,
    endTime: string | undefined,
    timeRangeValidationError: TimeRangeValidationError
}) => {

    const dayEnabled = !!(startTime && endTime);
    const invalidRange = !!(timeRangeValidationError.start || timeRangeValidationError.end) || (!startTime && endTime) || (startTime && !endTime)

    return (
        <div className="wh-time-visualiser">
            <div className="wh-bars-wrapper">
                {invalidRange
                    ? <div className="wh-bar-gray" data-testid='wh-bar-gray' />
                    : (
                        <>
                            {dayEnabled && <BarGreen startTime={formatTimeAsHHMM(startTime)} endTime={formatTimeAsHHMM(endTime)} />}
                            <div className="wh-bar-red" data-testid='wh-bar-red' />
                        </>
                    )
                }
            </div>
            <span className="wh-bar-start">00:00</span>
            <span className="wh-bar-end">23:59</span>
        </div>
    )
}

export const BarGreen = ({ startTime, endTime }: { startTime: string, endTime: string }) => {
    const barStart = mapTimeToPixels(startTime);
    const barEnd = mapTimeToPixels(endTime);
    const barLength = (barEnd - barStart);

    return (
        <div className="wh-bar-green" style={{ left: `${barStart}px`, width: `${barLength}px` }} data-testid='wh-bar-green' />
    )
}

export const mapTimeToPixels = (timeAsHHMM: string): number => {
    const n = Number(timeAsHHMM.replace(':', '').replace(/^0+/, '')) || 0;
    return n === 0 ? 0 : n / 10;
}
